function stickElem(stikyelement, bodyForElement , headetIfstickyDesk, headetIfstickyMob){
    if (document.querySelector(stikyelement) !== null){
        let getStikyHead = document.querySelector(stikyelement);
        getStikyHead.style.transform = 'translateY('+ 0 + 'px)';
        let getElemWidth = getStikyHead.offsetWidth;
        let elemCoordinates = getStikyHead.getBoundingClientRect().top + pageYOffset;
        let getHeaderHeight;
        let getBodyFormScroll = document.querySelector(bodyForElement).offsetHeight + elemCoordinates;
        let elemHeight = getStikyHead.offsetHeight;
        if (headetIfstickyDesk !== undefined && headetIfstickyMob !== undefined){
            if (window.innerWidth > 767){
                getHeaderHeight = document.querySelector(headetIfstickyDesk).offsetHeight;
            }else{
                getHeaderHeight = document.querySelector(headetIfstickyMob).offsetHeight;
            }
        }else{
            getHeaderHeight = 0;
        }
        var curScroll = 0;
        window.scrollBy(0,1);
        window.addEventListener('scroll', function() {
            let howMuchScroll = window.pageYOffset;
            let pxToScrollElem = howMuchScroll - elemCoordinates + getHeaderHeight;
            getStikyHead.classList.add('active');
            getStikyHead.style.zIndex = '100';
            getStikyHead.style.position = 'fixed';
            getStikyHead.style.width = getElemWidth + 'px';
            getStikyHead.style.top = '20px';
            if (howMuchScroll < elemCoordinates){
                pxToScrollElem = 0;
                getStikyHead.classList.remove('active');
                getStikyHead.style.position = 'relative';
                getStikyHead.style.top = '0px';
            }

            if (howMuchScroll > getBodyFormScroll - elemHeight){
                pxToScrollElem = curScroll;
                getStikyHead.classList.remove('active');
                getStikyHead.style.position = 'relative';
                getStikyHead.style.top = pxToScrollElem + 'px';
            }
            //getStikyHead.style.transform = 'translateY('+ pxToScrollElem + 'px)';
            curScroll = pxToScrollElem;
        });
    }
}

module.exports = stickElem;